import axios from "axios";

import baltex from "~/api/baltex";
import catalogSeo from "~/api/catalogSeo";
import home from "~/api/home";
import server from "~/api/legacyBff";
import lendings from "~/api/lendings";
import { axiosWrapper } from "~/utils/errors/axiosWrapper";

import brands from "./brands";
import cart from "./cart";
import catalog from "./catalog";
import content from "./content";
import databaseContent from "./databaseContent";
import databaseImages from "./databaseImages";
import databaseNews from "./databaseNews";
import databaseParams from "./databaseParams";
import managersData from "./managersData";
import models from "./models";
import news from "./news";
import pageMetaTracking from "./pageMetaTracking";
import product from "./product";
import props from "./props";
import sections from "./sections";
import services from "./services";
import sitemap from "./sitemap";

let API_URL = "/bxApi";
let API_SERVER_URL = "/api";
let SERVICE_DATABASE_API_URL = "/database";
/**
 * Тестовый стенд: контент запрашивается с флагом draft — бэкенд подменяет
 * data на черновик dataDraft и отдаёт ещё не опубликованные записи.
 * На проде переменная не задана.
 */
let IS_DRAFT_SITE = false;
if (typeof window === "undefined") {
  IS_DRAFT_SITE = String(process.env.IS_DRAFT_SITE ?? "") === "true";
  API_URL = `${process.env.BITRIX_API_URL}/bxApi`;
  SERVICE_DATABASE_API_URL = `${process.env.SERVICE_DATABASE_API_URL}/database`;
  API_SERVER_URL = `${process.env.LOCAL_HOST}/api`;
} else if (window.location.host.includes("farkop.ru")) {
  API_URL = "https://farkop.ru/bxApi";
}

const config = {
  API_URL,
  API_SERVER_URL,
  SERVICE_DATABASE_API_URL,
  IS_DRAFT_SITE,
};

export const Api = {
  cart: cart(axiosWrapper, config),
  catalog: catalog(axiosWrapper, config),
  catalogSeo: catalogSeo(axiosWrapper, config),
  product: product(axiosWrapper, config),
  models: models(axiosWrapper, config),
  content: content(axiosWrapper, config),
  news: news(axiosWrapper, config),
  pageMetaTracking: pageMetaTracking(axiosWrapper, config),
  services: services(axiosWrapper, config),
  brands: brands(axiosWrapper, config),
  sections: sections(axiosWrapper, config),
  props: props(axiosWrapper, config),
  sitemap: sitemap(axiosWrapper, config),
  server: server(axios, config),
  baltex: baltex(axiosWrapper, config),
  lendings: lendings(axiosWrapper, config),
  home: home(axiosWrapper, config),
  databaseParams: databaseParams(axiosWrapper, config),
  managersData: managersData(axiosWrapper, config),
  databaseContent: databaseContent(axiosWrapper, config),
  databaseImages: databaseImages(axiosWrapper, config),
  databaseNews: databaseNews(axiosWrapper, config),
};
